var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7170_7758)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    transform: "translate(0 0.5)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 62,
    height: 62,
    rx: 31,
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 31.5C33.21 31.5 35 29.71 35 27.5C35 25.29 33.21 23.5 31 23.5C28.79 23.5 27 25.29 27 27.5C27 29.71 28.79 31.5 31 31.5ZM31 33.5C28.33 33.5 23 34.84 23 37.5V39.5H39V37.5C39 34.84 33.67 33.5 31 33.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7170_7758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDefault);
export default __webpack_public_path__ + "static/media/userDefault.88cf84267b5535e107a548a9a97df080.svg";
export { ForwardRef as ReactComponent };